var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"mobile-container"},[_c('Head'),_c('Content',[_c('Main',{on:{"focusOut":_vm.handleFocusOut,"focusIn":_vm.handleFocusIn}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }